/**
 * MoreIcon/index.js
 * desc: more options menu icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const MoreIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="more icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.more.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 16 4" xmlns="http://www.w3.org/2000/svg"><path d="M4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2ZM6 2C6 3.1 6.9 4 8 4C9.1 4 10 3.1 10 2C10 0.9 9.1 0 8 0C6.9 0 6 0.9 6 2ZM14 4C12.9 4 12 3.1 12 2C12 0.9 12.9 0 14 0C15.1 0 16 0.9 16 2C16 3.1 15.1 4 14 4Z"/></svg>
    </IconButton>
);


export default MoreIcon;
